import React, { useState } from 'react';
import { api } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { KeyRound, Loader2 } from 'lucide-react';

export default function CambiarPasswordCard() {
  const [form, setForm] = useState({ actual: '', nueva: '', repetir: '' });
  const [guardando, setGuardando] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.actual || !form.nueva || !form.repetir) { toast.error('Rellena todos los campos'); return; }
    if (form.nueva.length < 8) { toast.error('La nueva contraseña debe tener al menos 8 caracteres'); return; }
    if (form.nueva !== form.repetir) { toast.error('La confirmación no coincide'); return; }
    setGuardando(true);
    try {
      await api.post('/admin/cambiar-password', form);
      toast.success('Contraseña actualizada');
      setForm({ actual: '', nueva: '', repetir: '' });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo cambiar la contraseña');
    } finally { setGuardando(false); }
  };

  return (
    <Card className="border-zinc-200" data-testid="cambiar-password-card">
      <CardHeader>
        <CardTitle className="font-heading flex items-center gap-2 text-lg">
          <KeyRound className="h-5 w-5" /> Cambiar mi contraseña
        </CardTitle>
        <CardDescription>Actualiza la contraseña con la que entras al panel. Mínimo 8 caracteres.</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Contraseña actual</Label>
            <Input type="password" value={form.actual} onChange={(e) => setForm({ ...form, actual: e.target.value })}
              autoComplete="current-password" data-testid="pwd-actual" required />
          </div>
          <div className="space-y-1.5">
            <Label>Nueva contraseña</Label>
            <Input type="password" value={form.nueva} onChange={(e) => setForm({ ...form, nueva: e.target.value })}
              autoComplete="new-password" minLength={8} data-testid="pwd-nueva" required />
          </div>
          <div className="space-y-1.5">
            <Label>Repite la nueva contraseña</Label>
            <Input type="password" value={form.repetir} onChange={(e) => setForm({ ...form, repetir: e.target.value })}
              autoComplete="new-password" data-testid="pwd-repetir" required />
          </div>
          <Button type="submit" disabled={guardando} className="bg-zinc-900 hover:bg-zinc-800" data-testid="pwd-save-btn">
            {guardando ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <KeyRound className="h-4 w-4 mr-1.5" />}
            {guardando ? 'Guardando...' : 'Cambiar contraseña'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
